"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
import { Facebook, Instagram, Twitter, Youtube } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterNavigation() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        <div className="h-5 w-24 bg-muted animate-pulse rounded" />
        <div className="h-4 w-20 bg-muted animate-pulse rounded" />
        <div className="h-4 w-20 bg-muted animate-pulse rounded" />
        <div className="h-4 w-20 bg-muted animate-pulse rounded" />
      </div>;
  }
  return <nav className="flex flex-col gap-3">
      <h3 className="font-display font-semibold text-base mb-1">Navegación</h3>
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="text-sm text-muted-foreground hover:text-primary transition-colors duration-[var(--duration-fast)]">
          {item.label}
        </Link>)}
    </nav>;
}
export default function PieDePagina() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const socialLinks = [{
    icon: Facebook,
    url: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Instagram,
    url: "https://instagram.com",
    label: "Instagram"
  }, {
    icon: Twitter,
    url: "https://twitter.com",
    label: "Twitter"
  }, {
    icon: Youtube,
    url: "https://youtube.com",
    label: "YouTube"
  }];
  return <footer id="pie-de-página" ref={ref} className={`bg-background py-16 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {}
          <div className="flex flex-col gap-4">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1539391/img/puertosabor_logo.png" alt="PuertoSabor Logo" className="h-7" />
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
              Cocina casera canaria y española en el corazón del Puerto de la Cruz. 
              Cada plato elaborado con alma, utilizando ingredientes de productores locales.
            </p>
          </div>

          {}
          <div className="flex justify-center md:justify-start">
            <MenuProvider menu_id="37">
              <FooterNavigation />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="font-display font-semibold text-base mb-1">Síguenos</h3>
            <div className="flex gap-4">
              {socialLinks.map((social, i) => <Link key={social.label} to={social.url} newTab data-index={i} className="text-muted-foreground hover:text-primary transition-all duration-[var(--duration-fast)] hover:scale-110" aria-label={social.label}>
                  <social.icon className="size-5" />
                </Link>)}
            </div>
          </div>
        </div>

        {}
        <Separator className="my-8" />

        {}
        <div className="text-center">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} PuertoSabor. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}